import { BENEFIT_ICONS_ENUM } from '@/_types/preventive-examination'

const sharedAssetsPath = `${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/legacy`

export const iconsMap: Record<BENEFIT_ICONS_ENUM, string> = {
	'icon-health-education': `${sharedAssetsPath}/icon-health-education.svg`,
	'icon-client-center': `${sharedAssetsPath}/icon-client-center.svg`,
	'icon-x-mark-blue': `${sharedAssetsPath}/icon-x-mark-blue.svg`,
	'icon-x-mark-cyclamen': `${sharedAssetsPath}/icon-x-mark-cyclamen.svg`,
	'icon-laboratory': `${sharedAssetsPath}/icon-laboratory.svg`,
	'icon-man': `${sharedAssetsPath}/icon-man.svg`,
	'icon-woman': `${sharedAssetsPath}/icon-woman.svg`,
	'icon-ok': `${sharedAssetsPath}/icon-ok.svg`,
	'icon-personal-development': `${sharedAssetsPath}/icon-personal-development.svg`,
	'icon-prevention': `${sharedAssetsPath}/icon-prevention.svg`,
	'icon-service-1': `${sharedAssetsPath}/icon-service-1.svg`,
	'icon-service-2': `${sharedAssetsPath}/icon-service-2.svg`,
	'icon-service-3': `${sharedAssetsPath}/icon-service-3.svg`,
	'icon-service-4': `${sharedAssetsPath}/icon-service-4.svg`,
	'icon-tooth': `${sharedAssetsPath}/icon-tooth.svg`
}

const oldIconsMap = {
	'icon-lab': 'icon-laboratory'
}

export const getIcon = (icon?: string) => {
	if (icon && iconsMap[icon as keyof typeof iconsMap]) {
		return iconsMap[icon as keyof typeof iconsMap]
	}

	if (icon && oldIconsMap[icon as keyof typeof oldIconsMap]) {
		return iconsMap[oldIconsMap[icon as keyof typeof oldIconsMap] as keyof typeof iconsMap]
	}

	// TODO: Remove this
	// if (!process.env.NODE_ENV === 'development') {
	console.warn(`[iconsMap.const.ts] Error: Icon ${icon} not found in iconsMap`)
	return iconsMap['icon-client-center']
}
